import { isWeb } from './platformHelpers';
import { LocalizePropType } from '../HoC/withTextLocalizer';
import { localizeStandalone } from './localizeStandalone';
import UserTypes from '../@types/redux/store/UserTypes';
import { showAlert } from './showAlert';
import { injectedStore as store } from '../globals/StoreAccess';

export const showAppReviewDialog = async (
  localize: LocalizePropType,
  bundleId: string,
  appleAppId: string,
  successCallback: () => void = () => {}
): Promise<any> => {
  if (!isWeb()) {
    const { showAlert } = await import('./showAlert');
    const { injectedRate } = await import('../globals/ConfigureGlobals');
    showAlert(
      localize('review.dialog.title'),
      localize('review.dialog.message'),
      localize('review.dialog.yes'),
      () => {
        injectedRate.rate(
          {
            AppleAppID: appleAppId,
            GooglePackageName: bundleId,
            preferInApp: true,
            openAppStoreIfInAppFails: true,
            inAppDelay: 5.0,
          },
          (success: boolean) => {
            if (success) {
              successCallback();
            }
          }
        );
      },
      localize('review.dialog.later')
    );
  }
};

export const showUserDuplicateDialog = async (
  violation: string,
  duplicateCallback: () => void = () => {}
) => {
  const category = (() => {
    const mapping: Record<string, string> = {
      email: 'email',
      phoneNumber: 'phone',
      'api_error.user.iban.duplicate': 'iban',
    };
    return mapping[violation] || violation;
  })();

  showAlert(
    '',
    await localizeStandalone(`user.duplicate.${category}.msg`),
    await localizeStandalone(`user.duplicate.${category}.yes`),
    () => {
      store.dispatch({ type: UserTypes.CLEAR_AUTH });
      setTimeout(() => {
        duplicateCallback();
      }, 100);
    },
    await localizeStandalone(`user.duplicate.${category}.cancel`),
    () => {}
  );
};

export const showUserYoungDialog = async (
  violation: string,
  minimalUserAge: number,
  youngUserCallback: () => void = () => {}
) => {
  const { showAlert } = await import('./showAlert');

  showAlert(
    '',
    await localizeStandalone(violation, minimalUserAge?.toString()),
    await localizeStandalone('ok'),
    () => {
      youngUserCallback();
    },
    '',
    () => {}
  );
};
